import React from 'react';
import Select from 'react-select';
import Layout from '../../components/layout/Layout';
import DataTable from '../../components/datatable/DataTable';
import Alert from '../../modal/alert/Alert';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import BallastCreateModal from '../../modal/ballast/BallastCreateModal';
import BallastEditModal from '../../modal/ballast/BallastEditModal';
import BallastDuplicateModal from '../../modal/ballast/BallastDuplicateModal';

import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { getColumnStyle, COLUMN_STYLE } from '../../components/datatable/util';
import {
  listBallastItems,
  deleteBallast,
  clearErrorBallast,
} from '../../redux/luminaire/ballast_actions';
import { defaultRejectHandler, getErrorValue, withDefaultSort } from '../../utils/utility';
import Constants from '../../config/constants';

class BallastsPage extends React.Component {
  constructor(props) {
    super(props);
    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const { t } = props;

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'is_public',
        Cell: row => row.value
          ? <span><i className="fas fa-users"/> {t('public')}</span>
          : <span><i className="fas fa-user"/> {t('private')}</span>,
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('brand')}</b>,
        accessor: 'brand_name',
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('power (W)')}</b>,
        accessor: 'power_required',
        ...getColumnStyle(COLUMN_STYLE.coefficient),
        width: 100,
      },
      {
        Header: () => <b>{t('type')}</b>,
        accessor: 'type_name',
        ...getColumnStyle(COLUMN_STYLE.text),
        width: 120,
      },
    ];

    this.state = {
      selectedInstance: null,
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li>
        <a
          href="#"
          id="lighting-ballast-create"
          data-toggle="modal"
          data-target="#create-ballast"
          onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{t('create ballast')}</span>
        </a>
      </li>,
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listBallastItems(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category.value],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      selectedInstance: item,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      t,
      errorMessage,
    } = this.props;

    const breadcrumbItems = [
      { name: t('ballast'), path: '/ballast' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_ballast.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <BallastCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <BallastEditModal
          ballast={item}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <BallastDuplicateModal
          item={item}
          show={isShowDuplicateModal}
          title={t('copy ballast')}
          label={t('new ballast name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete ballast')}
          body={`${t('do you want to delete')} ${item ? item.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? `${t('deleting')}...` : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteBallast(item)}
        />
        <h1>{t('ballast')}</h1>
        <div style={{ backgroundColor: 'white' }}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              id="lighting-ballast-search-name"
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, this.state.categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={this.state.categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(this.search.filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <DataTable
            columns={this.columns}
            data={this.props.items}
            onActionEdit={item => this.setState({ isShowEditModal: true, selectedInstance: item.original, isEdited: false })}
            onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedInstance: item.original, isDuplicated: false })}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const ballastState = state.lighting.ballast;
  return {
    items: ballastState.orderedIds.map(id => ballastState.items[id]),
    filteredCount: ballastState.filteredCount,
    isLoading: ballastState.isLoading,
    isCreating: ballastState.isCreating,
    isEditing: ballastState.isEditing,
    isDeleting: ballastState.isDeleting,
    isDuplicating: ballastState.isDuplicating,
    errorMessage: ballastState.errorMessage,
  }
};

const mapDispatchToProps = dispatch => ({
  listBallastItems: (pageSize, page, sorted, filtered, isPublic) =>
    dispatch(listBallastItems(pageSize, page, sorted, filtered, isPublic)),
  deleteBallast: ballast =>
    defaultRejectHandler(dispatch(deleteBallast(ballast.id))),
  clearError: () => dispatch(clearErrorBallast()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(BallastsPage)
);


// WEBPACK FOOTER //
// ./src/pages/ballast/BallastsPage.js